module.exports = __webpack_public_path__ + "img/dc.b4059ed8.svg";